import { render, staticRenderFns } from "./ContentLengthScores.vue?vue&type=template&id=13d45a33&scoped=true&"
import script from "./ContentLengthScores.vue?vue&type=script&lang=js&"
export * from "./ContentLengthScores.vue?vue&type=script&lang=js&"
import style0 from "./ContentLengthScores.vue?vue&type=style&index=0&id=13d45a33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d45a33",
  null
  
)

/* custom blocks */
import block0 from "./ContentLengthScores.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports